var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 18.9993C12.792 19 12.6988 19 12.5924 19H7.7973C6.81912 19 6.3293 19 5.95532 18.8094C5.62604 18.6417 5.35852 18.3737 5.19074 18.0444C5 17.6701 5 17.1803 5 16.2002V7.80017C5 6.82008 5 6.32967 5.19074 5.95532C5.35852 5.62604 5.62604 5.35852 5.95532 5.19074C6.32967 5 6.82008 5 7.80017 5H16.2002C17.1803 5 17.6696 5 18.044 5.19074C18.3733 5.35852 18.6417 5.62604 18.8094 5.95532C19 6.3293 19 6.81912 19 7.7973V12.5904C19 12.6976 19 12.7915 18.9992 12.875M12.875 18.9993C13.1249 18.997 13.283 18.988 13.434 18.9517C13.6126 18.9089 13.7831 18.8379 13.9397 18.7419C14.1163 18.6337 14.2676 18.4828 14.5703 18.1801L18.1801 14.5703C18.4828 14.2676 18.6333 14.1163 18.7415 13.9397C18.8374 13.7831 18.9084 13.6121 18.9513 13.4336C18.9875 13.2826 18.9968 13.1248 18.9992 12.875M12.875 18.9993V14.2751C12.875 13.785 12.875 13.5398 12.9704 13.3527C13.0543 13.188 13.188 13.0543 13.3527 12.9704C13.5398 12.875 13.7846 12.875 14.2747 12.875H18.9992",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowIcon);
export default __webpack_public_path__ + "static/media/workflow-icon.e670066e00cf26761d646e7e0c81ceb7.svg";
export { ForwardRef as ReactComponent };